const baseurllocal = () => import(/* webpackPrefetch: true */ '@/views/public/baseurl/index.vue')

const login = () => import(/* webpackPrefetch: true */ '@/views/public/index.vue')

const routes = [
  {
    path: "/baseurllocal",
    name: "baseurllocal",
    component: baseurllocal,
    meta: {
      title: "Base Url Local"
    }
  },

  {
    path: "/login",
    name: "login",
    component: login,
    meta: {
      title: "Masuk"
    }
  }
]
export default routes.map(route => {
  const meta = {
    all: false, 
    public: true,
    onlyLoggedOut: true,
    title: route.meta.title
  }
  return { ...route, meta }
})